import { Button, Layout, Spin } from 'antd'
import { t } from 'i18next'
import React, { useContext, useEffect, useState } from 'react'
import { get, post } from '../../Common/api'
import { Color } from '../../Common/Color'
import OwnerFilter from './OwnerFilter'
import OwnerList from './OwnerList'
import OwnerForm from './OwnerForm'
import { useForm } from 'antd/es/form/Form'
import { PlusOutlined } from '@ant-design/icons'
import CustModal from '../../Common/CustModal'
import GlobalContext from '../GlobalContext'

export default function OwnersPage () {
  const [owners, setOwners] = useState([])
  const [filter, setFilter] = useState({ name: '' })
  const [loading, setLoading] = useState(false)
  const [modalVisible, setModalVisible] = useState(false)
  const [form] = useForm()
  const { notificationApi } = useContext(GlobalContext)

  useEffect(() => {
    getOwners()
  }, [])

  const getOwners = async () => {
    setLoading(true)
    await get({
      url: 'admin/owners',
      params: { scope: 'filtered_list' },
      onSuccess: (res) => {
        setLoading(false)
        setOwners(res.owners)
      },
      onFailure: () => {
        setLoading(false)
      }
    })
  }

  const postOwner = async (params) => {
    setLoading(true)
    await post({
      url: 'admin/owners',
      params,
      notification: { api: notificationApi, state: 'create' },
      onSuccess: () => {
        setModalVisible(false)
        setLoading(false)
        getOwners()
      },
      onFailure: (errors) => {
        setLoading(false)
        form.setFields(
          Object.keys(errors).map((key) => ({
            name: key,
            errors: errors[key]
          }))
        )
      }
    })
  }

  const onChangeFilter = (filter) => {
    setFilter(filter)
  }

  const filteredOwners = owners.filter((owner) => {
    return owner.name.toLowerCase().includes(filter.name.toLowerCase())
  })

  const openAddModal = () => {
    form.resetFields()
    setModalVisible(true)
  }

  const onAdd = async (values) => {
    await postOwner(values)
  }

  return (
    <Layout>
      <Layout style={{ padding: '1em 0', color: Color.dark_blue, fontSize: '24px' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{ marginRight: '20px' }}><b>{owners.length}</b> {t('Admin.OwnersPage.title')}</div>
          <OwnerFilter filter={filter} onChangeFilter={onChangeFilter} />
          <Button onClick={openAddModal} type="primary" style={{ marginLeft: 'auto' }} shape="circle" icon={<PlusOutlined />} />
        </div>
      </Layout>
      <Spin spinning={loading}>
        <OwnerList owners={filteredOwners} />
        <CustModal
          open={modalVisible}
          setOpen={setModalVisible}
          width="1000px"
          title={t('Admin.OwnersPage.addOwnerTitle')}
          onOk={form.submit}
          confirmLoading={loading}
        >
          <Spin spinning={loading}>
            <OwnerForm form={form} onFinish={onAdd} />
          </Spin>
        </CustModal>
      </Spin>
    </Layout>
  )
}
